<template>
    <page-view title="代理机构银行账户管理">
        <a-card>
            <a-row type="flex">
                <a-col :span="20">
                    <a-form class="mb-5" layout="inline" :form="form">
                        <a-form-item>
                            <a-select
                                    style="width: 100px;"
                                    @change="onChange"
                                    v-model="initData.state">
                                <a-select-option value="1">启用</a-select-option>
                                <a-select-option value="0">停用</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-form>
                </a-col>
                <a-col class="text-right" :span="4">
                    <a-form-item>
                        <a-button type="primary" @click="onAdd" icon="plus">新增账户</a-button>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <s-table
                            ref="table"
                            :columns="columns"
                            :data="loadData"
                            :customRow="onRow"
                            :pagination="{ showTotal: total => `总共 ${total} 条` }"
                            :rowKey="record => record.id"
                            class="border"
                            size="middle"
                    >
                        <template slot="index" slot-scope="text, record, index">
                            {{index + 1}}
                        </template>
                        <template
                                slot="orgName"
                                slot-scope="record"
                        >
                            {{record.extras.orgName}}
                        </template>
                        <template
                                slot="bankAccountName"
                                slot-scope="record"
                        >
                            {{record.bankAccountName}}
                        </template>
                        <template
                                slot="bankAccount"
                                slot-scope="record"
                        >
                            {{record.bankAccount}}
                        </template>
                        <template
                                slot="bankName"
                                slot-scope="record"
                        >
                            {{record.bankName}}
                        </template>
                        <template slot="cmtName" slot-scope=" record">
                            {{record.cmtName}}
                        </template>
                        <template
                                slot="cmtDate"
                                slot-scope="record"
                        >
                            {{record.cmtDate}}
                        </template>
                        <template slot="state" slot-scope="record">
                            <a-tag color="blue" v-if="record.state === '1'">启用</a-tag>
                            <a-tag v-if="record.state === '0'">停用</a-tag>
                        </template>
                        <template slot="operate" slot-scope="record">
                            <a @click="onEdit(record)">编辑</a>
                            <a-divider type="vertical" />
                            <a v-if="record.state === '1'"  @click="editSate(record)">停用</a>
                            <a v-if="record.state === '0'" @click="editSate(record)">启用</a>
                            <a-divider type="vertical" />
                            <a class="color-ash" @click="onDel(record)">删除</a>
                        </template>
                    </s-table>
                    <AgencyBankInfoAdd :visible="addVisible" ref="add" @cancel="addCancel"></AgencyBankInfoAdd>
                    <AgencyBankInfoEdit :visible="editVisible" ref="edit" @cancel="editCancel"></AgencyBankInfoEdit>
                </a-col>
            </a-row>
        </a-card>
    </page-view>
</template>

<script>
  import { PageView } from '@/layouts'
  import STable from '@/components/Table'
  import qs from 'qs'
  import moment from 'moment'
  import AgencyBankInfoAdd from './AgencyBankInfoAdd'
  import AgencyBankInfoEdit from './AgencyBankInfoEdit'

  export default {
    name: '',
    components: {
      PageView,
      STable,
      moment,
      AgencyBankInfoAdd,
      AgencyBankInfoEdit
    },
    data () {
      return {
        form: this.$form.createForm(this),
        queryParam: {},
        initData: {
          state: '1'
        },
        addVisible: false,
        editVisible: false,
        columns: [
          {
            title: '机构名称',
            width: '15%',
            ellipsis: true,
            scopedSlots: { customRender: 'orgName' }
          },
          {
            title: '账户名称',
            width: '15%',
            ellipsis: true,
            align: 'center',
            scopedSlots: { customRender: 'bankAccountName' }
          },
          {
            title: '银行账户',
            width: '15%',
            ellipsis: true,
            align: 'center',
            scopedSlots: { customRender: 'bankAccount' }
          },
          {
            title: '开户行',
            width: '15%',
            ellipsis: true,
            align: 'center',
            scopedSlots: { customRender: 'bankName' }
          },
          {
            title: '更新人',
            width: '15%',
            ellipsis: true,
            align: 'center',
            scopedSlots: { customRender: 'cmtName' }
          },
          {
            title: '更新时间',
            ellipsis: true,
            width: '15%',
            align: 'center',
            scopedSlots: { customRender: 'cmtDate' }
          },
          {
            title: '状态',
            width: '60px',
            align: 'center',
            scopedSlots: { customRender: 'state' }
          },
          {
            title: '操作',
            width: '180px',
            align: 'center',
            scopedSlots: { customRender: 'operate' }
          }
        ],
        modalVisible: {
          addView: false,
          editView: false
        },
        list: [],
        loadData: parameter => {
          return this.$http.get('/api/v1/agency/getList.json', {
            params: Object.assign(parameter, this.queryParam),
            paramsSerializer: function (params) {
              return qs.stringify(params, { indices: false })
            }
          }).then(res => {
            this.loading = false
            console.log(res)
            this.list = res.result
            return res
          })
        },
        onRow: record => {
          return {
            on: {
              click: () => {
                // this.onView(record)
              }
            }
          }
        }
      }
    },
    methods: {
      onSearch () {
        this.loading = true
        this.queryParam = { ...this.initData }
        this.$refs.table.refresh(true)
      },
      onChange(value,option) {
        this.onSearch()
      },
      editSate(record) {
        let params = {}
        var msg = ''
        params.id = record.id
        if (record.state === '1') {
          msg = '停用成功'
          params.state = '0'
        }else if (record.state === '0') {
          msg = '启用成功'
          params.state = '1'
        }
        if (!params.state) {
          this.$message.info('数据异常')
          return
        }
        let that = this
        this.$http.post('/api/v1/agency/editState.json', qs.stringify(params)).then(function (res) {
          if (res.code) {
            that.$message.info(msg)
            that.$refs.table.refresh()
          }
        })
      },
      onEdit (record) {
        this.$refs.edit.initInfo(record.id)
        this.editVisible = true
      },
      onAdd () {
        this.addVisible = true
      },
      addCancel () {
        this.addVisible = false
        this.$refs.table.refresh()
      },
      editCancel () {
        this.editVisible = false
        this.$refs.table.refresh()
      },
      onDel (record) {
        let that = this
        this.$confirm({
          title: '你确定要删除这条数据吗?',
          content:"删除后将不可找回,请谨慎操作!",
          onOk(){
          that.$http.get('/api/v1/agency/del.json?id=' + record.id).then(function (res) {
            if (res.code === 200) {
                that.$message.info('删除成功')
                that.$refs.table.refresh()
              }
            })
          },
          onCancel(){
          }
        });

      }
    }
  }
</script>

<style scoped>
    /deep/ .page-header .detail .main .extra{
        margin-left: 0;
    }
</style>
